module.exports = __webpack_public_path__ + "static/media/review-5.35aa2fb8.png";